import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  color: var(--textAndLabels-main);
  background: var(--bg-main);

  padding: 35px 80px 30px;

  @media (max-width: ${BREAKPOINTS.desktop}) {
    padding: 58px 40px 30px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 50px 16px 30px;
  }

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    content: ' ';
    width: 100%;
    height: 1px;
    background-color: var(--border-main);
  }
`;

export const Section = styled.div`
  width: 100%;
  column-count: 5;
  column-gap: 45px;

  @media (max-width: ${BREAKPOINTS.desktop}) {
    column-count: 4;
    column-gap: 20px;
  }
`;

export const SubFooterTitle = styled(Typography).attrs({ variant: 'h3' })`
  margin-bottom: 50px;
`;

export const NavigationTitle = styled(Typography).attrs({ variant: 'title4' })`
  margin-bottom: 20px;
`;

export const NavigationItem = styled.div`
  break-inside: avoid;
  margin-bottom: 50px;
`;
